import * as React from 'react';
// @ts-expect-error
import type {RouterHistory} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {RightFrame, NavButtons, ModalMain} from 'shells/modal/step-modal/layout';
import {Body} from 'shells/typography/body';
import {ModalHeader} from 'shells/typography/modal-header';

import {DONE_APP, DONE_SMS} from '../constants';
import {ViewRecoveryCodesScreen} from '../screens/view-recovery-codes-screen';
import type {Method} from '../types';

import styles from './recovery-codes.module.css';

type Props = {
    method: Method;
    history: RouterHistory;
};

export function RecoveryCodes(props: Props) {
    const [continueButtonDisabled, setContinueButtonDisabled] = React.useState(true);

    return (
        <RightFrame>
            <ModalMain>
                <div className={styles.top}>
                    <ModalHeader>Everything’s been verified!</ModalHeader>
                    {props.method === 'sms' && (
                        <Body>From now on, we’ll text you a code to enter whenever you log in</Body>
                    )}

                    {props.method === 'app' && (
                        <Body>
                            From now on, you’ll enter a code from an app whenever you log in
                        </Body>
                    )}
                </div>

                <ViewRecoveryCodesScreen
                    onNextReady={() => {
                        setContinueButtonDisabled(false);
                    }}
                    method={props.method}
                />
            </ModalMain>
            <NavButtons>
                <React.Fragment>
                    <Button
                        variant='primary'
                        size='big'
                        onClick={() => {
                            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                            props.method === 'sms'
                                ? props.history.push(DONE_SMS)
                                : props.history.push(DONE_APP);
                        }}
                        disabled={continueButtonDisabled}
                    >
                        I saved these codes
                    </Button>
                </React.Fragment>
            </NavButtons>
        </RightFrame>
    );
}
